<template>
  <div>
    <h5>Documents</h5>
    
    <!-- Akta Pendirian -->
    <div class="document-item mb-3 p-3 border rounded d-flex justify-content-between align-items-center">
      <div class="document-name">
        Akta Pendirian dan SK Kemenkumham
      </div>
      <div class="document-upload d-flex align-items-center">
        <label for="aktaPendirian" class="mb-0 cursor-pointer d-flex align-items-center">
          <img src="/assets/ic_pdf.png" width="24px" alt="PDF" class="mr-2" />
          <a class="text-link" :href="akta_pendirian_url" target="_blank">{{ akta_pendirian }}</a>
        </label>
      </div>
    </div>
    
    <!-- Surat Izin Operasional -->
    <div class="document-item mb-3 p-3 border rounded d-flex justify-content-between align-items-center">
      <div class="document-name">
        Surat Izin Operasional yang Berlaku
      </div>
      <div class="document-upload d-flex align-items-center">
        <label for="suratIzin" class="mb-0 cursor-pointer d-flex align-items-center">
          <img src="/assets/ic_pdf.png" width="24px" alt="PDF" class="mr-2" />
          <a class="text-link" :href="siup_url" target="_blank">{{ siup }}</a>
        </label>
      </div>
    </div>
    
    <!-- NIB Perusahaan -->
    <div class="document-item mb-3 p-3 border rounded d-flex justify-content-between align-items-center">
      <div class="document-name">
        NIB Perusahaan
      </div>
      <div class="document-upload d-flex align-items-center">
        <label for="nibPerusahaan" class="mb-0 cursor-pointer d-flex align-items-center">
          <img src="/assets/ic_pdf.png" width="24px" alt="PDF" class="mr-2" />
          <a class="text-link" :href="nib_url" target="_blank">{{ nib }}</a>
        </label>
      </div>
    </div>
    
    <!-- Identitas Pribadi Direktur -->
    <div class="document-item mb-3 p-3 border rounded d-flex justify-content-between align-items-center">
      <div class="document-name">
        Identitas Pribadi Direktur Utama
      </div>
      <div class="document-upload d-flex align-items-center">
        <label for="identitasDirektur" class="mb-0 cursor-pointer d-flex align-items-center">
          <img src="/assets/ic_img.png" width="24px" alt="PDF" class="mr-2" />
          <a class="text-link" :href="id_direktur_url" target="_blank">{{ id_direktur }}</a>
        </label>
      </div>
    </div>
    
    <!-- Identitas Beneficial Owner -->
    <div class="document-item mb-3 p-3 border rounded d-flex justify-content-between align-items-center">
      <div class="document-name">
        Identitas Pribadi Beneficial Owner
      </div>
      <div class="document-upload d-flex align-items-center">
        <label for="identitasOwner" class="mb-0 cursor-pointer d-flex align-items-center">
          <img src="/assets/ic_img.png" width="24px" alt="PDF" class="mr-2" />
          <a class="text-link" :href="id_owner_url" target="_blank">{{ id_owner }}</a>
        </label>
      </div>
    </div>
    
    <!-- Surat Kuasa -->
    <div class="document-item mb-3 p-3 border rounded d-flex justify-content-between align-items-center">
      <div class="document-name">
        Surat Kuasa
      </div>
      <div class="document-upload d-flex align-items-center">
        <label for="suratKuasa" class="mb-0 cursor-pointer d-flex align-items-center">
          <img src="/assets/ic_pdf.png" width="24px" alt="PDF" class="mr-2" />
          <a class="text-link" :href="surat_kuasa_url" target="_blank">{{ surat_kuasa }}</a>
        </label>
      </div>
    </div>
    
    <!-- Akta Perubahan -->
    <div class="document-item mb-3 p-3 border rounded d-flex justify-content-between align-items-center">
      <div class="document-name">
        Akta Perubahan
      </div>
      <div class="document-upload d-flex align-items-center">
        <label for="aktaPerubahan" class="mb-0 cursor-pointer d-flex align-items-center">
          <img src="/assets/ic_pdf.png" width="24px" alt="PDF" class="mr-2" />
          <a class="text-link" :href="akta_perubahan_url" target="_blank">{{ akta_perubahan }}</a>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {computed} from 'vue';

export default {
  name: "Documents",
  props : {
    data : {
      type: Object,
      required: true
    }
  },
  setup(props){
    const akta_pendirian = computed(() => props.data.akta_pendirian_filename  || '');
    const akta_pendirian_url = computed(() => props.data.akta_pendirian_url || '');
    const siup = computed(() => props.data.surat_izin_operasional_filename || '');
    const siup_url = computed(() => props.data.surat_izin_operasional_url || '');
    const nib = computed(() => props.data.nib_file_filename || '');
    const nib_url = computed(() => props.data.nib_file_url || '');
    const id_direktur = computed(() => props.data.direktur_utama_id_filename || '');
    const id_direktur_url = computed(() => props.data.direktur_utama_id_url || '');
    const id_owner = computed(() => props.data.beneficial_owner_id_filename || '');
    const id_owner_url = computed(() => props.data.beneficial_owner_id_url || '');
    const surat_kuasa = computed(() => props.data.surat_kuasa_filename || '');
    const surat_kuasa_url = computed(() => props.data.surat_kuasa_url || '');
    const akta_perubahan = computed(() => props.data.akta_perubahan_filename || '');
    const akta_perubahan_url = computed(() => props.data.akta_perubahan_url || '');

    return {
      akta_pendirian,
      siup,
      nib,
      id_direktur,
      id_owner,
      surat_kuasa,
      akta_perubahan,
      akta_pendirian_url,
      siup_url,
      nib_url,
      id_direktur_url,
      id_owner_url,
      surat_kuasa_url,
      akta_perubahan_url
    };
  }
};
</script>

<style scoped>
.document-item {
  background-color: #ffffff;
  transition: all 0.2s ease;
}

.cursor-pointer {
  cursor: pointer;
}

.document-name {
  font-weight: 500;
}

.text-link{
  font-family: "IBM Plex Sans Devanagari";
  color: #007AFF;
  line-height: 100%;
  font-size: 16px;
  font-weight: 400;
}
</style>